// import { createApp } from 'vue/dist/vue.esm-bundler';

// import Header from './twig/components/header/Header.vue';


import './js/site';
import Site from './js/site';

// import 'slick-slider/slick/slick.scss';
import './styles/styles.scss';

const site = new Site();

// const emitter = mitt();
// const app = createApp({
//   components: {
//     // Header,
//   },
// });

// app.mount('#app');
